import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import _ from "lodash";
import { default as React, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import {
  creatDeleverOrder,
  nbfCustomerByID,
  nbfCustomerTrayAccount,
  nbfModificationItems,
  nbfOrderDetailPage,
  nbfTrayStore,
  trayUpdate,
} from "../../api/restApi";
import { customersData } from "../../store/reducer/customersSlice";
import { ordersData } from "../../store/reducer/ordersSlice";
import {
  ConvertOrderArrayToObject,
  discountPriceItems,
  discountPriceOnArrearsZero,
  resolveUnitPriceForCustomer,
} from "../../utils/helpers";
import { useAppSelector } from "../../utils/hooks";
import {
  VoucherItem,
  VoucherItemType,
  VoucherType,
  createAccountVoucher,
} from "../../utils/vouchers/vouchersHelper";
import { getAccountCodeForCustomer } from "../Accounts/Account/HelperClass";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeliverPaymentModal({
  detailOpen,
  customerId,
  date,
  handleClose,
  handleStatus,
  orderByCustomer,
}) {
  const { customers } = useAppSelector(customersData);
  const [customer, setCustomer] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [paymentMode, setPaymentMode] = useState([
    "EasyPaisa",
    "JazzCash",
    "Account",
    "Cash",
  ]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [discount, setDiscount] = useState(0);
  const name = useSelector((state) => state.currentUser.name);
  const { ordersDate } = useAppSelector(ordersData);
  const [productsOption, setProductsOption] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const product = useSelector((state) => state.products.products);
  const sortedOrdersDate = [...ordersDate].sort(
    (a, b) => new Date(b) - new Date(a)
  );
  const level_3 = useAppSelector((state) => state.accountLevels.level3);
  const reasonType = ["Wastage", "Staff", "Guest"];
  const [selectedDate, setSelectedDate] = useState(sortedOrdersDate[0] || "");
  const [selectedReasonType, setSelectedReasonType] = useState(
    reasonType[0] || ""
  );
  const [quantity, setQuantity] = useState(0);
  const [trayPending, setTrayPending] = useState();
  const [tray, setTray] = useState({
    trayA_received: 0,
    trayB_received: 0,
    trayA_dispatch: 0,
    trayB_dispatch: 0,
  });
  const [addTray, setAddTray] = useState({
    trayA_received: 0,
    trayB_received: 0,
    trayA_dispatch: 0,
    trayB_dispatch: 0,
  });
  const [customerTrayAccount, setCustomerTrayAccount] = useState();
  console.log("********", customerId);

  const [returnTableList, setReturnTableList] = useState([]);
  const handleSelectDate = async (event, newValue) => {
    setSelectedDate(newValue);
  };
  const handleSelectProduct = async (event, newValue) => {
    setSelectedProduct(newValue);
  };
  const handleReasonType = async (event, newValue) => {
    setSelectedReasonType(newValue);
  };

  useEffect(() => {
    setProductsOption([
      ...product.map((data) => {
        data = {
          ...data,
          label: data.name_english + " " + data.name_urdu,
        };
        return data;
      }),
    ]);
  }, [product]);

  const calculateTotalSum = (list) => {
    const returnAmount = list.reduce((sum, item) => {
      return sum + (item.totalReturnAmount || 0);
    }, 0);

    setCustomerInvoiceDetails((pre) => {
      const updatedDetails = {
        ...pre,
        return: returnAmount,
        grandTotal: pre.total - returnAmount - Number.parseInt(discount),
        list,
      };
      return updatedDetails;
    });
    updateAmountPaid(list);
  };

  const handleAddReturn = () => {
    if (selectedProduct && quantity > 0) {
      const targetCustomer = selectedCustomer || findCustomer(customerId);
      let resolvedPrice = resolveUnitPriceForCustomer(selectedProduct, targetCustomer);
      if (resolvedPrice === undefined || resolvedPrice === null || resolvedPrice === "") {
        return;
      }
      if (typeof resolvedPrice === "string") {
        resolvedPrice = parseFloat(resolvedPrice.replace(/,/g, ""));
      }
      if (isNaN(resolvedPrice)) {
        console.log("Invalid price format");
        return;
      }
      const totalReturnAmount = Math.round(resolvedPrice * quantity);
      let list = [];
      const existingProductIndex = returnTableList.findIndex(
        (item) => item.name_english === selectedProduct.name_english
      );
      if (existingProductIndex !== -1) {
        const updatedreturnTableList = [...returnTableList];
        updatedreturnTableList[existingProductIndex].quantity = quantity;
        updatedreturnTableList[existingProductIndex].totalReturnAmount =
          totalReturnAmount;
        setReturnTableList([...updatedreturnTableList]);
        list = [...updatedreturnTableList];
      } else {
        const newRow = {
          id: selectedProduct.id,
          name_english: selectedProduct.name_english,
          name_urdu: selectedProduct.name_urdu,
          quantity: quantity,
          date: selectedDate,
          reason: selectedReasonType,
          totalReturnAmount: totalReturnAmount,
        };
        setReturnTableList([...returnTableList, newRow]);
        list = [...returnTableList, newRow];
      }
      setSelectedProduct(null);
      setQuantity(0);
      calculateTotalSum(list);
    }
  };

  const trayA_receivedRef = useRef(null);
  const trayB_receivedRef = useRef(null);
  const trayA_dispatchRef = useRef(null);
  const trayB_dispatchRef = useRef(null);

  const checkTrayAccount = customerTrayAccount?.find(
    (el) => customerId === parseInt(el.id)
  );

  const handleAddTray = () => {
    if (checkTrayAccount === undefined) {
      return alert("Please Create Tray Account First From Setting");
    }

    setTray({
      trayA_received: trayA_receivedRef.current.value || 0,
      trayB_received: trayB_receivedRef.current.value || 0,
      trayA_dispatch: trayA_dispatchRef.current.value || 0,
      trayB_dispatch: trayB_dispatchRef.current.value || 0,
    });
  };

  const [customerInvoiceDetails, setCustomerInvoiceDetails] = useState({
    bill: 0,
    arrears: 0,
    return: 0,
    discount: 0,
    amountPaid: 0,
    total: 0,
    grandTotal: 0,
    balance: 0,
    paymentMode: "",
    delivery_charges: 0,
    advancePayment: 0,
    user: name,
  });

  const inputRef = useRef(null);

  async function callData(date) {
    setOpenLoader(true);
    try {
      setCustomer([]);
      setDiscount(0);
      let data = await nbfOrderDetailPage(date, customerId);
      data = ConvertOrderArrayToObject([data]);
      let customersData = _.find(data.orders_customer, {
        customerId: customerId,
      }); //find by id
      if (!customersData) {
        customersData = _.find(data.orders_customer, {
          customerId: parseFloat(customerId),
        }); //find by id
      }
      let newData = { ...customersData, ...findCustomer(customerId) };

      setSelectedCustomer(newData);
      console.log(newData);
      let disc = 0;
      discountPriceItems.filter((item) => {
        const matchingItem = newData.order?.find(
          (orderItem) => orderItem.id + "" === item.id + ""
        );
        if (matchingItem) {
          disc = disc + item.discount * matchingItem.quantity;
        }
        return matchingItem !== undefined;
      });
      if (!discountPriceOnArrearsZero) {
        disc = 0;
      }
      setDiscount(disc);

      setOpenLoader(false);
    } catch {
      setOpenLoader(false);
    }
  }

  const findCustomer = (id) => {
    let cust = customers.find((el) => el.id.toString() === id.toString());
    return {
      ...cust,
      label: cust.name_urdu ? cust.name_urdu : cust.name_english,
    };
  };

  //**********discount ********/
  useEffect(() => {
    const fetchData = async () => {
      try {
        const singleCustomer = await nbfCustomerByID(selectedCustomer.id);
        const order = selectedCustomer.order;
        const bill = order.reduce((acc, item) => {
          const price = parseFloat(item.price.toString().replace(/,/g, ""));
          return acc + item.quantity * price;
        }, 0);

        const delivery_charges =
          singleCustomer.customer.delivery_charges &&
          singleCustomer.customer.delivery_charges
            ? singleCustomer.customer.delivery_charges
            : 0;
        const arrears = singleCustomer.customer.arrearAmount;

        const total =
          parseFloat(bill.toString().replace(/,/g, "")) +
          parseFloat(delivery_charges) +
          parseFloat(arrears);
        if (arrears > 0) {
          setDiscount(0);
        }
        const grandTotal =
          arrears <= 0 && discount > 0
            ? parseFloat(total.toString().replace(/,/g, "")) - discount
            : parseFloat(total.toString().replace(/,/g, ""));

        const balance = grandTotal;
        setCustomerInvoiceDetails((pre) => ({
          ...pre,
          arrears,
          delivery_charges,
          bill,
          total,
          grandTotal,
          balance,
          return: 0,
          amountPaid: 0,
          customerId: selectedCustomer.id,
        }));
      } catch (error) {
        console.log(error);
      }
    };

    if (selectedCustomer) {
      fetchData();
    }
  }, [selectedCustomer]);

  const handleSelectPayment = async (event, newValue) => {
    setSelectedPayment(newValue);
  };

  useEffect(() => {
    {
      date && callData(date);
    }
  }, [date, customerId]);

  useEffect(() => {
    console.log("first");
    const fetchData = async () => {
      try {
        const trayInfo = await nbfTrayStore(customerId);
        console.log(trayInfo);
        setTrayPending(trayInfo);
      } catch (error) {
        console.error("Error fetching tray info:", error);
      }
    };

    customerId && fetchData();
  }, [customerId]);

  console.log(trayPending);

  useEffect(() => {
    const fetchData = async () => {
      const trayAccount = await nbfCustomerTrayAccount();
      setCustomerTrayAccount(trayAccount);
    };

    fetchData();
  }, [customerId]);

  console.log(trayPending);

  const updateAmountPaid = (list) => {
    setCustomerInvoiceDetails((pre) => {
      const updatedDetails = {
        ...pre,
        arrears: pre.arrears,
        amountPaid: inputRef.current.value,
        balance:
          inputRef.current.value >= pre.grandTotal
            ? Number.parseInt(0)
            : pre.grandTotal - inputRef.current.value,
        advancePayment:
          inputRef.current.value > pre.grandTotal
            ? inputRef.current.value - pre.grandTotal
            : 0,
      };
      return updatedDetails;
    });
  };

  const handleSubmitData = async () => {
    handleAddReturn();
    const order = await nbfModificationItems(date, customerId);
    if (!customerInvoiceDetails.return && !customerInvoiceDetails.amountPaid) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Need to add some Payment or return !",
        width: "95%",
      });
    } else {
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: "Do You want to submit this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Submit it!",
        width: "95%",
      });
      if (confirmed.isConfirmed) {
        try {
          handleClose();
          //Send WhatsApp message from here......
          await creatDeleverOrder(customerInvoiceDetails, order);
          let level3Code = getAccountCodeForCustomer(level_3, customerId);
          let saleAmount =
            parseInt(customerInvoiceDetails.bill) +
            parseInt(customerInvoiceDetails.delivery_charges) -
            parseInt(customerInvoiceDetails.return);
          console.log(customerInvoiceDetails, saleAmount);
          let type = VoucherType.sale;
          await createAccountVoucher(type, [
            new VoucherItem({
              transaction: VoucherItemType.debit,
              amount: saleAmount,
              code: level3Code,
              particular: selectedCustomer?.name_english,
              description: "Sales Credit",
              type,
            }),
            // code hardcoded for now
            new VoucherItem({
              transaction: VoucherItemType.credit,
              amount: saleAmount,
              code: "18-001-0001",
              particular: "Key Customer Sale",
              description: "Key Customer Sale",
              type,
            }),
          ]);
          if (parseInt(customerInvoiceDetails.amountPaid + "") > 0) {
            let type = VoucherType.cashReceived; //on delivered always received in cash.
            await createAccountVoucher(type, [
              new VoucherItem({
                transaction: VoucherItemType.debit,
                amount: customerInvoiceDetails.amountPaid,
                code: "07-001-0001",
                particular: "Cash payment",
                Discription: "Cash payment",
                type,
              }),
              
              new VoucherItem({
                transaction: VoucherItemType.credit,
                amount: customerInvoiceDetails.amountPaid,
                code: level3Code,
                particular: selectedCustomer?.name_english,
                description: "Bill paid on delivery",
                type,
              }),
            ]);
          }

          // let createCashVoucher = await createCustomerSaleVoucher(
          //   level3Code,
          //   selectedCustomer?.name_english,
          //   saleAmount,
          //   customerInvoiceDetails.amountPaid
          // );

          const check = customerTrayAccount?.find(
            (el) => customerId === parseInt(el.id)
          );
          if (check !== undefined) {
            const response = await trayUpdate({
              id: customerId,
              trayAReturn: tray.trayA_received,
              trayBReturn: tray.trayB_received,
              trayADispatch: tray.trayA_dispatch,
              trayBDispatch: tray.trayB_dispatch,
            });
          }

          toast.success("Successfully Submit Order !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          handleStatus(date);
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={detailOpen}
        onClose={handleClose}
        TransitionComponent={Transition}
        style={{ zIndex: 1000 }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h5" align="center">
              Delivered-Order-Payment
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box sx={{ flexGrow: 0, padding: { xs: "0.5rem", md: "1rem" } }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card
                variant="outlined"
                sx={{ width: "100%", height: "84vh", overflowY: "auto" }}
              >
                <CardContent>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="0rem"
                  >
                    <label style={{ minWidth: "49%" }}>
                      <Typography
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        {date}
                      </Typography>
                    </label>
                    <label style={{ minWidth: "49%" }}>
                      <Typography
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        {selectedCustomer?.name_urdu}
                      </Typography>
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "100%" }}>
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        sx={{ width: "100%" }}
                        onClick={handleSubmitData}
                      >
                        SUBMIT
                      </Button>
                    </label>
                  </Stack>

                  {/* ****************_Payment_**************** */}
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "49%" }}>
                      <TextField
                        inputRef={inputRef}
                        type="number"
                        label="Payment"
                        sx={{ minWidth: "100%" }}
                      />
                    </label>
                    <label style={{ minWidth: "49%" }}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo3"
                        options={paymentMode}
                        sx={{ minWidth: "100%" }}
                        value={selectedPayment}
                        onChange={handleSelectPayment}
                        renderInput={(params) => (
                          <TextField {...params} label="Mode" />
                        )}
                      />
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "100%" }}>
                      <Button
                        variant="contained"
                        sx={{ minWidth: "100%" }}
                        onClick={updateAmountPaid}
                      >
                        ADD Payment
                      </Button>
                    </label>
                  </Stack>

                  {/* **************_Tray_*********************                  */}
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "49%" }}>
                      <TextField
                        name="trayA_dispatch"
                        sx={{ minWidth: "100%" }}
                        type="number"
                        label="Tray A Dispatch"
                        inputRef={trayA_dispatchRef}
                        // value={addTray?.trayA_dispatch}
                        // onChange={handleTray}
                      />
                    </label>
                    <label style={{ minWidth: "49%" }}>
                      <TextField
                        name="trayB_dispatch"
                        sx={{ minWidth: "100%" }}
                        type="number"
                        label="Tray B Dispatch"
                        inputRef={trayB_dispatchRef}
                        // value={addTray?.trayB_dispatch}
                        // onChange={handleTray}
                      />
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "49%" }}>
                      <TextField
                        name="trayA_received"
                        sx={{ minWidth: "100%" }}
                        type="number"
                        label="Tray A Received"
                        inputRef={trayA_receivedRef}
                      />
                    </label>
                    <label style={{ minWidth: "49%" }}>
                      <TextField
                        name="trayB_received"
                        sx={{ minWidth: "100%" }}
                        type="number"
                        label="Tray B Received"
                        inputRef={trayB_receivedRef}
                      />
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "100%" }}>
                      <Button
                        variant="contained"
                        onClick={handleAddTray}
                        sx={{ minWidth: "100%", mt: 1 }}
                      >
                        Add Tray
                      </Button>
                    </label>
                  </Stack>

                  {/* *****************return******************** */}
                  <Stack direction="row" spacing={1} marginBottom="1rem">
                    <label style={{ minWidth: "49%" }}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={sortedOrdersDate}
                        sx={{ minWidth: "100%" }}
                        value={selectedDate}
                        onChange={handleSelectDate}
                        renderInput={(params) => (
                          <TextField {...params} label="Select a date" />
                        )}
                      />
                    </label>
                    <label style={{ minWidth: "49%" }}>
                      <Autocomplete
                        disablePortal
                        label="Select Product"
                        id="combo-box-demo2"
                        options={reasonType}
                        sx={{ minWidth: "100%" }}
                        value={selectedReasonType || null}
                        onChange={handleReasonType}
                        renderInput={(params) => (
                          <TextField {...params} label="Reason of return" />
                        )}
                      />
                    </label>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <label style={{ minWidth: "49%" }}>
                      <Autocomplete
                        disablePortal
                        label="Select Product"
                        id="combo-box-demo"
                        options={productsOption}
                        sx={{ minWidth: "100%" }}
                        value={selectedProduct || null}
                        onChange={handleSelectProduct}
                        renderInput={(params) => (
                          <TextField {...params} label="Return" />
                        )}
                      />
                    </label>
                    <label style={{ minWidth: "49%" }}>
                      <TextField
                        sx={{ minWidth: "100%" }}
                        type="number"
                        label="Quantity"
                        value={quantity || ""}
                        onChange={(e) => setQuantity(e.target.value)}
                      />
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "100%" }}>
                      <Button
                        variant="contained"
                        onClick={handleAddReturn}
                        sx={{ minWidth: "100%", mt: 1 }}
                      >
                        Add Return
                      </Button>
                    </label>
                  </Stack>

                  {/* *************** Return Product Table **************          */}
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Price</TableCell>
                        <TableCell align="center">Quantity</TableCell>
                        <TableCell align="center">Name Urdu</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {returnTableList.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">
                            {row.totalReturnAmount}
                          </TableCell>
                          <TableCell align="center">{row.quantity}</TableCell>
                          <TableCell align="center">{row.name_urdu}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>

            {/* ******************* Detail of Bill Card********************** */}
            <Grid item xs={12} md={6}>
              <Card
                variant="outlined"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  height: "84vh",
                }}
              >
                <CardContent>
                  {selectedCustomer && (
                    <Card variant="outlined" sx={{ width: 320, mt: "0rem" }}>
                      <CardContent>
                        <Grid xs={12} sx={{}}>
                          <Table
                            aria-label="simple table"
                            sx={{
                              maxWidth: 300,
                            }}
                          >
                            <TableRow
                              sx={{
                                backgroundColor: "lightgray",
                                height: "5vh",
                              }}
                            >
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  height: 6,
                                  width: "50%",
                                  textAlign: "justify",
                                }}
                              >
                                {customerInvoiceDetails.bill}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                  height: 6,
                                }}
                              >
                                بل
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: "#E49393" }}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {customerInvoiceDetails.arrears}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                بقایا جات
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {customerInvoiceDetails.delivery_charges}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                ترسیلی چارجز
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: "lightgray" }}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {customerInvoiceDetails.total}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                کل
                              </TableCell>
                            </TableRow>
                            {customerInvoiceDetails.return > 0 && (
                              <TableRow sx={{ backgroundColor: "#E49393" }}>
                                <TableCell
                                  align="center"
                                  style={{
                                    fontSize: 15,
                                    padding: 8,
                                    textAlign: "justify",
                                  }}
                                >
                                  {customerInvoiceDetails.return}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{
                                    textAlign: "end",
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    padding: 8,
                                  }}
                                >
                                  واپسی
                                </TableCell>
                              </TableRow>
                            )}
                            {customerInvoiceDetails.arrears == 0 &&
                              discount > 0 && (
                                <TableRow sx={{ backgroundColor: "#609EA2" }}>
                                  <TableCell
                                    align="center"
                                    style={{
                                      fontSize: 15,
                                      padding: 8,
                                      textAlign: "justify",
                                    }}
                                  >
                                    {discount}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      textAlign: "end",
                                      fontWeight: "bold",
                                      fontSize: 15,
                                      padding: 8,
                                    }}
                                  >
                                    رعایت
                                  </TableCell>
                                </TableRow>
                              )}
                            <TableRow sx={{ backgroundColor: "#609EA2" }}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {customerInvoiceDetails.grandTotal}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                کل رقم
                              </TableCell>
                            </TableRow>
                            {customerInvoiceDetails.amountPaid > 0 && (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  style={{
                                    fontSize: 15,
                                    padding: 8,
                                    textAlign: "justify",
                                  }}
                                >
                                  {customerInvoiceDetails.amountPaid}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{
                                    textAlign: "end",
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    padding: 8,
                                  }}
                                >
                                  ادائیگی
                                </TableCell>
                              </TableRow>
                            )}
                            <TableRow sx={{ backgroundColor: "#E49393" }}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {customerInvoiceDetails.balance}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                بقیہ
                              </TableCell>
                            </TableRow>
                          </Table>
                        </Grid>
                      </CardContent>
                    </Card>
                  )}

                  {/* ******************* Detail of Tray Card********************** */}
                  <Card variant="outlined" sx={{ width: 320, mt: "0.5rem" }}>
                    {checkTrayAccount !== undefined ? (
                      <CardContent>
                        <Grid xs={12} sx={{}}>
                          <Table
                            aria-label="simple table"
                            sx={{
                              maxWidth: 300,
                            }}
                          >
                            <TableRow
                              sx={{
                                backgroundColor: "#E49393",
                                height: "5vh",
                              }}
                            >
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  height: 6,
                                  width: "50%",
                                  textAlign: "justify",
                                }}
                              >
                                بسکٹ ٹرے
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                میٹھائی ٹرے
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                  height: 6,
                                }}
                              >
                                ڈیٹیل
                              </TableCell>
                            </TableRow>

                            <TableRow
                              sx={{
                                backgroundColor: "lightgray",
                              }}
                            >
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  height: 6,
                                  width: "50%",
                                  textAlign: "justify",
                                }}
                              >
                                {tray?.trayB_dispatch}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {tray?.trayA_dispatch}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                  height: 6,
                                }}
                              >
                                آج کا ٹرے
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: "lightgray" }}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {trayPending?.trayBPending}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {trayPending?.trayAPending}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                ٹرے پینڈنگ
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: "lightgray" }}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {tray?.trayB_received}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {tray.trayA_received}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                واپسی
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: "lightgray" }}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {parseInt(tray.trayB_dispatch) +
                                  parseInt(trayPending?.trayBPending) -
                                  parseInt(tray.trayB_received)}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: 15,
                                  padding: 8,
                                  textAlign: "justify",
                                }}
                              >
                                {parseInt(tray.trayA_dispatch) +
                                  parseInt(trayPending?.trayAPending) -
                                  parseInt(tray.trayA_received)}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  textAlign: "end",
                                  fontWeight: "bold",
                                  fontSize: 15,
                                  padding: 8,
                                }}
                              >
                                بقیہ
                              </TableCell>
                            </TableRow>
                          </Table>
                        </Grid>
                      </CardContent>
                    ) : (
                      <CardContent>
                        <Typography>No tray account</Typography>
                      </CardContent>
                    )}
                  </Card>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  );
}
